// @ts-strict-ignore
import * as React from 'react';

import {SpinnerReact} from 'common/components/spinner';
import {useTranslation} from 'common/i18n/hooks';

import {BarPreview} from './charts/bar';
import {ChartPreviewCarousel} from './chart-preview-carousel';
import {FunnelPreview} from './charts/funnel';
import {LinePreview} from './charts/line';
import {FunnelBreakdownPreview} from './charts/funnel-breakdown';

const CHART_PREVIEW_MAX = 4;

export const EventChartPreviewCarousel = ({events}) => {
  const {t} = useTranslation();

  if (!events || events.length === 0) {
    return <SpinnerReact />;
  }

  const eventsToShow = events.slice(0, CHART_PREVIEW_MAX);

  return (
    <ChartPreviewCarousel>
      <FunnelPreview events={eventsToShow} cardTitle={t(`onboarding.chart.funnel-title`)} />
      <LinePreview events={eventsToShow} cardTitle={t(`onboarding.chart.line-default-title`)} />
      <BarPreview events={eventsToShow} cardTitle={t(`onboarding.chart.bar-default-title`)} />
    </ChartPreviewCarousel>
  );
};

export const PropertyBreakdownPreviewCarouselV2 = ({events, property, breakdown, pauseRotation, selectedEvent}) => {
  const {t} = useTranslation();

  let toShow = [];
  if (!breakdown?.length) {
    toShow = [`Property A`, `Property B`, `Property C`];
  } else {
    toShow = breakdown.slice(0, CHART_PREVIEW_MAX);
  }
  const LineCardDefaultTitle = t(`onboarding.chart.line-default-title`);
  const FunnelBreakdownCardDefaultTitle = t(`onboarding.chart.funnel-breakdown-default-title`);
  const BarCardDefaultTitle = t(`onboarding.chart.bar-default-title`);

  const cardTitle = t(`onboarding.chart.breakdown-custom-title`, {selectedEvent, property});

  const missingTitleInfo = !selectedEvent || !property;

  return (
    <ChartPreviewCarousel pauseRotation={pauseRotation}>
      <LinePreview events={toShow} cardTitle={missingTitleInfo ? LineCardDefaultTitle : cardTitle} />
      <FunnelBreakdownPreview
        events={events.slice(0, CHART_PREVIEW_MAX)}
        property={property}
        properties={toShow}
        cardTitle={missingTitleInfo ? FunnelBreakdownCardDefaultTitle : cardTitle}
      />
      <BarPreview events={toShow} cardTitle={missingTitleInfo ? BarCardDefaultTitle : cardTitle} />
    </ChartPreviewCarousel>
  );
};
